import React from "react";
import { CategoryProduct } from "../../../domain/entities/CategoryProduct";
import CardProductComponents from "./CardProductComponents";

interface ListProductsRegisterSuparkProps {
    category: CategoryProduct;
    onProductId: (productId: number, price: number) => void;
}

const ListProductsRegisterSupark: React.FC<ListProductsRegisterSuparkProps> = ({ category, onProductId }) => {

    const handleClickProduct = (productId: number, price: number) => {
        onProductId(productId, price);
    }

    return (
        <>
            {category.slug === "sudirman-park" && (
            <CardProductComponents
                onProductId={handleClickProduct}
                productItems={category.products}
            />
            )}
        </>
    );
};

export default ListProductsRegisterSupark;